import React from 'react';
import Skeleton from 'ui/Skeleton';

const PartnerFeedbackSummaryLoading = () => {
  return (
    <div data-testid="PartnerFeedbackSummaryLoading">
      <Skeleton height={30} className="mb-24 mt-30" />
      <Skeleton height={175} />
      <Skeleton height={32} width="20%" lines={2} className="mt-24 w-20" />
    </div>
  );
};

export default PartnerFeedbackSummaryLoading;
